import request from '@/utils/request'

export function getConnect(params) {
  return request({
    url: `/mqtt/connect`,
    method: 'get',
    params
  })
}
